import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import WhiteLabelService from "../../services/whiteLabelService";
import { NotificationManager } from "react-notifications";
import { useEffect } from "react";
import RetailHeader from "../venue-retail/retail-header";
import RetailMenu from "../venue-retail/retail-menu";
import RetailInfo from "../venue-retail/retail-info";
import RetailPhotos from "../venue-retail/retail-photos";
import { identifyVenue, trackEvent } from "../../utils/mixpanelUtil";
import { SET_VENUE_DATA } from "../../redux/actions/types";
import { useDispatch } from "react-redux";
import { isEmpty } from "../../utils/common";

const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

const VenuePharmacy = () => {
  const [details, setDetails] = useState({});
  const dispatch = useDispatch();
  const [currency, setCurrency] = useState("");
  const { app_key: pharmacy_id } = useParams();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = () => {
    localStorage.removeItem("venueData");
    WhiteLabelService.getDetails(pharmacy_id).then(
      (res) => {
        // if (res.allowed_only_from !== "pharmacy") {
        //   navigate("/");
        // } else {
        dispatch({ type: SET_VENUE_DATA, payload: res.venue });
        setDetails(res.venue);

        setCurrency(res.currency);

        identifyVenue(pharmacy_id);
        trackEvent("White Label - Pharmacy", {
          action_category: "Page Load",
          action_outcome: "success",
          interaction_element: "screen",
          industry: "pharmacy_management",
          source: "vb_web",
        });
        // }
      },
      (error) => {
        NotificationManager.error(
          error?.message ||
            "Oops! Something went wrong. Please try again or contact us directly at contact@venueboost.io.",
          "Error",
          3000
        );

        identifyVenue(pharmacy_id);
        trackEvent("White Label - Pharmacy", {
          action_category: "Page Load",
          action_outcome: "fail",
          interaction_element: "screen",
          industry: "pharmacy_management",
          source: "vb_web",
        });
      }
    );
  };

  const showSocials =
    details?.other_customations?.facebook_link ||
    details?.other_customations?.instagram_link ||
    details?.other_customations?.twitter_link ||
    details?.other_customations?.linkedin_link ||
    details?.other_customations?.pinterest_link;
  const showComm =
    details?.other_customations?.call_us_text ||
    details?.other_customations?.support_phone;

  const outOfStockBrand = details?.brand_profile?.filter(
    (item) => item.element_name === "OutOfStock"
  )[0];
  const outOfStockData = {
    text: isEmpty(
      outOfStockBrand?.venue_brand_profile_customizations?.find(
        (c) => c.customization_key == "text"
      )?.customization_value
    )
      ? outOfStockBrand?.default_name
      : outOfStockBrand?.venue_brand_profile_customizations?.find(
          (c) => c.customization_key == "text"
        )?.customization_value,
    bgColor: outOfStockBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "color"
    )?.customization_value,
    textColor: outOfStockBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "text_color"
    )?.customization_value,
  };

  const cartPlusButtonBrand = details?.brand_profile?.filter(
    (item) => item.element_name === "CartPlusButton"
  )[0];
  const cartPlusButtonData = {
    text: isEmpty(
      cartPlusButtonBrand?.venue_brand_profile_customizations?.find(
        (c) => c.customization_key == "text"
      )?.customization_value
    )
      ? cartPlusButtonBrand?.default_name
      : cartPlusButtonBrand?.venue_brand_profile_customizations?.find(
          (c) => c.customization_key == "text"
        )?.customization_value,
    bgColor: cartPlusButtonBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "color"
    )?.customization_value,
    textColor: cartPlusButtonBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "text_color"
    )?.customization_value,
  };

  const SubscribeButtonBrand = details?.brand_profile?.filter(
    (item) => item.element_name === "SubscribeBtn"
  )[0];
  const SubscribeButtonData = {
    text: isEmpty(
      SubscribeButtonBrand?.venue_brand_profile_customizations?.find(
        (c) => c.customization_key == "text"
      )?.customization_value
    )
      ? SubscribeButtonBrand?.default_name
      : SubscribeButtonBrand?.venue_brand_profile_customizations?.find(
          (c) => c.customization_key == "text"
        )?.customization_value,
    bgColor: SubscribeButtonBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "color"
    )?.customization_value,
    textColor: SubscribeButtonBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "text_color"
    )?.customization_value,
  };

  const TagsBrand = details?.brand_profile?.filter(
    (item) => item.element_name === "Tags"
  )[0];
  const TagsButtonData = {
    text: isEmpty(
      TagsBrand?.venue_brand_profile_customizations?.find(
        (c) => c.customization_key == "text"
      )?.customization_value
    )
      ? TagsBrand?.default_name
      : TagsBrand?.venue_brand_profile_customizations?.find(
          (c) => c.customization_key == "text"
        )?.customization_value,
    bgColor: TagsBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "color"
    )?.customization_value,
    textColor: TagsBrand?.venue_brand_profile_customizations?.find(
      (c) => c.customization_key == "text_color"
    )?.customization_value,
  };

  const onSubscribe = () => {
    if (email.match(isValidEmail)) {
      const payload = {
        email: email,
      };
      WhiteLabelService.emailSubscribe(payload, pharmacy_id)
        .then((data) => {
          NotificationManager.success(
            data?.message ||
              "Thank you for subscribing to our newsletter. We will keep you updated with the latest news and updates.",
            "Success",
            3000
          );
          setEmail("");
        })
        .catch((error) => {
          NotificationManager.error(
            error?.error ||
              "Oops! Something went wrong. Please try again or contact us directly at contact@venueboost.io.",
            "Error",
            3000
          );
        });
    } else {
      NotificationManager.warning(
        "Please enter a valid email address.",
        "Error",
        3000
      );
    }
  };

  return (
    <div className="flex flex-col">
      <RetailHeader TagsButtonData={TagsButtonData} data={details} />

      <div className="bg-white">
        {/*// TODO: do we need this for web/mobile*/}
        {/*<RetailTab data={details} />*/}
        <div className="grid md:grid-cols-5 md:mt-6 gap-10 grid-cols-1 max-w-screen-main mx-auto  w-full">
          <RetailPhotos photos={details?.photos ?? []} />
          {details?.photos?.length > 0 && <RetailInfo data={details} />}
        </div>
        <div className="grid md:grid-cols-1 grid-cols-1 gap-10 max-w-screen-main mx-auto  w-full">
          <RetailMenu
            menuItems={details?.menu ?? {}}
            venueKey={pharmacy_id}
            venueName={details?.overview?.venue_name}
            venueLogo={details?.overview?.logo}
            currency={currency}
            outOfStockData={outOfStockData}
            cartPlusButtonData={cartPlusButtonData}
          />
          {details?.photos?.length === 0 && <RetailInfo data={details} />}
        </div>

        {details?.other_customations && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-[28px] mb-32">
            {details?.other_customations?.show_newsletter && (
              <div className="rounded-lg border border-[#DEE2E6] px-10 py-9 flex flex-col gap-4">
                <div className=" text-[#222222] font-bold text-20">
                  {details?.other_customations?.subscribe_label_text}
                </div>
                <div className="border border-[#DEE2E6] rounded-lg pl-6 flex flex-row justify-between">
                  <input
                    type="email"
                    className="border-none font-semibold text-14 w-full focus:border-none focus:outline-none h-[44px]"
                    placeholder="Your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  ></input>
                  <input
                    type="button"
                    style={{
                      backgroundColor: SubscribeButtonData
                        ? SubscribeButtonData?.bgColor
                        : "#240B3B",
                      color: SubscribeButtonData
                        ? SubscribeButtonData?.textColor
                        : "white",
                    }}
                    className="bg-[#240B3B] cursor-pointer rounded-lg font-semibold text-14 px-5 py-3"
                    value={
                      SubscribeButtonData
                        ? SubscribeButtonData?.text
                        : "Subscribe"
                    }
                    onClick={onSubscribe}
                  />
                </div>
              </div>
            )}

            <div className="rounded-lg border border-[#DEE2E6] px-10 py-9 gap-10 grid grid-cols-1 lg:grid-cols-5">
              {showComm && (
                <div className="flex flex-col gap-4 lg:col-span-3">
                  {details?.other_customations?.call_us_text && (
                    <div className=" text-[#222222] font-bold text-20">
                      {details?.other_customations?.call_us_text}
                    </div>
                  )}
                  {details?.other_customations?.support_phone && (
                    <div className="border border-[#DEE2E6] rounded-lg flex flex-row justify-between bg-[#EBEBEB] items-center pl-4 gap-2">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.8235 20.9996C15.9085 20.9996 14.6232 20.6686 12.6985 19.5933C10.3581 18.2808 8.54774 17.0691 6.21993 14.7474C3.97555 12.5044 2.88337 11.0522 1.35477 8.27066C-0.372103 5.13003 -0.0777282 3.48378 0.251334 2.78019C0.643209 1.93925 1.22165 1.43628 1.9693 0.937065C2.39397 0.658832 2.84337 0.420323 3.3118 0.224565C3.35868 0.204409 3.40227 0.18519 3.44118 0.167846C3.67321 0.0633151 4.02477 -0.0946537 4.47008 0.0740963C4.76727 0.185659 5.03258 0.41394 5.4479 0.824096C6.29962 1.6641 7.46352 3.53488 7.8929 4.45363C8.18118 5.07285 8.37196 5.4816 8.37243 5.94003C8.37243 6.47675 8.10243 6.89066 7.77477 7.33738C7.71337 7.42128 7.65243 7.50144 7.59337 7.57925C7.23665 8.048 7.15837 8.18347 7.20993 8.42535C7.31446 8.91144 8.09399 10.3585 9.37508 11.6368C10.6562 12.915 12.0615 13.6453 12.5495 13.7494C12.8016 13.8033 12.9399 13.7218 13.4237 13.3524C13.4931 13.2994 13.5643 13.2446 13.6388 13.1897C14.1385 12.818 14.5332 12.555 15.0573 12.555H15.0601C15.5162 12.555 15.9066 12.7528 16.5535 13.0791C17.3973 13.5047 19.3243 14.6536 20.1695 15.5063C20.5806 15.9207 20.8098 16.185 20.9218 16.4818C21.0906 16.9285 20.9316 17.2786 20.8281 17.513C20.8107 17.5519 20.7915 17.5946 20.7713 17.6419C20.574 18.1095 20.3341 18.558 20.0546 18.9816C19.5563 19.7269 19.0515 20.3039 18.2087 20.6963C17.7759 20.901 17.3023 21.0047 16.8235 20.9996Z"
                          fill="#240B3B"
                        />
                      </svg>
                      <input
                        className="border-none font-semibold text-14 w-full focus:border-none focus:outline-none h-[44px] disabled:bg-[#EBEBEB] rounded-lg text-[#595959]"
                        placeholder="Your email"
                        value={details?.other_customations?.support_phone}
                        disabled
                      ></input>
                    </div>
                  )}
                </div>
              )}

              {showSocials && (
                <div className="flex flex-col gap-4 lg:col-span-2">
                  {details?.other_customations?.social_media_label_text && (
                    <div className=" text-[#222222] font-bold text-20">
                      {details?.other_customations?.social_media_label_text}
                    </div>
                  )}
                  <div className="flex flex-row justify-between gap-4 items-center h-[44px]">
                    {details?.other_customations?.tiktok_link && (
                      <a
                        aria-label="TikTok Account"
                        target="_blank"
                        href={details?.other_customations?.tiktok_link}
                      >
                        <svg
                          width="19"
                          height="22"
                          viewBox="0 0 19 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.213 5.49139C16.913 5.45139 15.733 4.82839 14.844 3.99539C14.3581 3.53263 13.9731 2.97438 13.7132 2.35572C13.4534 1.73705 13.3243 1.07134 13.334 0.400391H9.712V14.3534C9.712 16.6324 8.346 17.9754 6.668 17.9754C6.22295 17.9802 5.78225 17.8875 5.37691 17.7036C4.97157 17.5198 4.61143 17.2494 4.32185 16.9114C4.03226 16.5734 3.82026 16.1761 3.70076 15.7474C3.58127 15.3186 3.55718 14.8689 3.63019 14.4299C3.70321 13.9908 3.87155 13.5731 4.12337 13.2061C4.3752 12.8392 4.70438 12.5318 5.08777 12.3058C5.47116 12.0797 5.89943 11.9404 6.34245 11.8976C6.78547 11.8549 7.23247 11.9098 7.652 12.0584V8.37439C7.32887 8.30338 6.99884 8.2685 6.668 8.27039C5.34962 8.2698 4.06068 8.66021 2.96421 9.39226C1.86774 10.1243 1.013 11.1651 0.508112 12.383C0.00322294 13.6008 -0.129136 14.9411 0.127777 16.2342C0.384689 17.5273 1.01933 18.7152 1.95143 19.6475C2.88353 20.5799 4.0712 21.2149 5.36423 21.4722C6.65727 21.7295 7.99756 21.5976 9.21559 21.093C10.4336 20.5885 11.4747 19.7341 12.207 18.6378C12.9394 17.5416 13.3302 16.2528 13.33 14.9344V7.42439C14.734 8.39539 16.411 8.85439 18.201 8.88639L18.213 5.49139Z"
                            fill="#240B3B"
                          />
                        </svg>
                      </a>
                    )}

                    {details?.other_customations?.instagram_link && (
                      <a
                        aria-label="Instagram Account"
                        target="_blank"
                        href={details?.other_customations?.instagram_link}
                      >
                        <svg
                          width="23"
                          height="24"
                          viewBox="0 0 23 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.4629 2.77507C14.4689 2.77507 14.8209 2.78807 16.0089 2.84207C17.1089 2.89107 17.7019 3.07407 18.0989 3.23007C18.6269 3.43607 19.0019 3.67707 19.3949 4.07007C19.7879 4.46307 20.0329 4.83807 20.2349 5.36507C20.3859 5.76207 20.5739 6.35607 20.6229 7.45507C20.6759 8.64307 20.6899 8.99507 20.6899 12.0011C20.6899 15.0071 20.6759 15.3601 20.6229 16.5481C20.5729 17.6471 20.3909 18.2411 20.2339 18.6381C20.054 19.127 19.767 19.5695 19.3939 19.9331C19.0318 20.3075 18.5893 20.5947 18.0999 20.7731C17.7019 20.9251 17.1079 21.1131 16.0099 21.1611C14.8209 21.2151 14.4689 21.2281 11.4629 21.2281C8.45689 21.2281 8.10489 21.2151 6.91689 21.1611C5.81689 21.1121 5.22389 20.9291 4.82689 20.7731C4.3376 20.5933 3.89476 20.3063 3.53089 19.9331C3.15633 19.5707 2.86908 19.1278 2.69089 18.6381C2.53989 18.2411 2.35189 17.6471 2.30289 16.5481C2.24989 15.3601 2.23589 15.0081 2.23589 12.0021C2.23589 8.99607 2.24989 8.64307 2.30289 7.45507C2.35289 6.35607 2.53489 5.76207 2.69189 5.36507C2.89689 4.83807 3.13789 4.46307 3.53189 4.07007C3.894 3.69563 4.33648 3.4084 4.82589 3.23007C5.22389 3.07807 5.81789 2.89007 6.91589 2.84207C8.10489 2.78407 8.46189 2.77507 11.4629 2.77507ZM11.4629 0.74707C8.40789 0.74707 8.02389 0.76007 6.82289 0.81407C5.62589 0.86807 4.80889 1.06007 4.09289 1.33707C3.34178 1.61945 2.66178 2.06322 2.10089 2.63707C1.52954 3.19963 1.08614 3.87871 0.800891 4.62807C0.526891 5.34307 0.334891 6.16007 0.280891 7.36107C0.225891 8.55807 0.212891 8.94207 0.212891 11.9971C0.212891 15.0521 0.225891 15.4361 0.279891 16.6371C0.333891 17.8341 0.525891 18.6511 0.802891 19.3701C1.08527 20.1212 1.52904 20.8012 2.10289 21.3621C2.66543 21.9334 3.34452 22.3768 4.09389 22.6621C4.80889 22.9391 5.62589 23.1311 6.82689 23.1851C8.02889 23.2381 8.40789 23.2521 11.4669 23.2521C14.5269 23.2521 14.9069 23.2381 16.1069 23.1851C17.3049 23.1311 18.1219 22.9391 18.8409 22.6621C19.592 22.3797 20.272 21.9359 20.8329 21.3621C21.4042 20.7995 21.8476 20.1204 22.1329 19.3711C22.4089 18.6561 22.6009 17.8391 22.6549 16.6371C22.7079 15.4361 22.7219 15.0571 22.7219 11.9971C22.7219 8.93707 22.7079 8.55807 22.6549 7.35707C22.6009 6.16007 22.4089 5.34307 22.1319 4.62407C21.8495 3.87296 21.4057 3.19296 20.8319 2.63207C20.2693 2.06075 19.5902 1.61735 18.8409 1.33207C18.1259 1.05507 17.3089 0.86307 16.1079 0.81007C14.9019 0.76007 14.5179 0.74707 11.4629 0.74707Z"
                            fill="#240B3B"
                          />
                          <path
                            d="M11.4626 6.57952C9.92964 6.57979 8.45958 7.18901 7.37581 8.27315C6.29204 9.3573 5.68333 10.8276 5.68359 12.3605C5.68386 13.8935 6.29308 15.3635 7.37722 16.4473C8.46137 17.5311 9.93164 18.1398 11.4646 18.1395C12.2236 18.1394 12.9752 17.9898 13.6764 17.6992C14.3776 17.4086 15.0147 16.9827 15.5514 16.4459C16.088 15.9091 16.5136 15.2718 16.804 14.5705C17.0944 13.8692 17.2437 13.1176 17.2436 12.3585C17.2435 11.5995 17.0938 10.8479 16.8032 10.1467C16.5126 9.44548 16.0868 8.80837 15.55 8.27174C15.0131 7.73511 14.3759 7.30947 13.6746 7.01912C12.9733 6.72877 12.2216 6.57939 11.4626 6.57952ZM11.4626 16.1055C10.4678 16.1055 9.51369 15.7103 8.81024 15.0069C8.10679 14.3034 7.71159 13.3494 7.71159 12.3545C7.71159 11.3597 8.10679 10.4056 8.81024 9.70217C9.51369 8.99872 10.4678 8.60352 11.4626 8.60352C12.4574 8.60352 13.4115 8.99872 14.115 9.70217C14.8184 10.4056 15.2136 11.3597 15.2136 12.3545C15.2136 13.3494 14.8184 14.3034 14.115 15.0069C13.4115 15.7103 12.4574 16.1055 11.4626 16.1055ZM17.4696 7.69652C17.6498 7.70143 17.8291 7.67018 17.997 7.60462C18.1649 7.53906 18.318 7.44051 18.4471 7.31481C18.5763 7.1891 18.679 7.03879 18.7491 6.87273C18.8192 6.70668 18.8553 6.52827 18.8553 6.34802C18.8553 6.16778 18.8192 5.98936 18.7491 5.82331C18.679 5.65726 18.5763 5.50694 18.4471 5.38124C18.318 5.25553 18.1649 5.15699 17.997 5.09143C17.8291 5.02587 17.6498 4.99462 17.4696 4.99952C17.1183 5.00909 16.7846 5.15536 16.5395 5.40721C16.2945 5.65906 16.1573 5.99661 16.1573 6.34802C16.1573 6.69944 16.2945 7.03699 16.5395 7.28884C16.7846 7.54069 17.1183 7.68696 17.4696 7.69652Z"
                            fill="#240B3B"
                          />
                        </svg>
                      </a>
                    )}

                    {details?.other_customations?.twitter_link && (
                      <a
                        aria-label="Twitter Account"
                        target="_blank"
                        href={details?.other_customations?.twitter_link}
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.9517 9.392L20.5997 0.5H18.7867L12.1447 8.22L6.84068 0.5H0.72168L8.74368 12.175L0.72168 21.5H2.53468L9.54868 13.347L15.1517 21.5H21.2697L12.9497 9.392H12.9517ZM10.4677 12.278L9.65468 11.116L3.18768 1.865H5.97168L11.1917 9.33L12.0047 10.493L18.7887 20.197H16.0037L10.4677 12.279V12.278Z"
                            fill="#240B3B"
                          />
                        </svg>
                      </a>
                    )}

                    {details?.other_customations?.facebook_link && (
                      <a
                        aria-label="Facebook Account"
                        target="_blank"
                        href={details?.other_customations?.facebook_link}
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.7695 0.5C16.5695 0.5 21.2695 5.229 21.2695 11.064C21.2695 16.338 17.4295 20.708 12.4095 21.5V14.118H14.8565L15.3225 11.064H12.4095V9.084C12.4095 8.248 12.8155 7.433 14.1195 7.433H15.4445V4.833C15.4445 4.833 14.2425 4.627 13.0945 4.627C10.6945 4.627 9.12753 6.089 9.12753 8.737V11.064H6.46253V14.118H9.12853V21.5C4.10953 20.708 0.269531 16.338 0.269531 11.064C0.269531 5.229 4.96953 0.5 10.7695 0.5Z"
                            fill="#240B3B"
                          />
                        </svg>
                      </a>
                    )}

                    {details?.other_customations?.linkedin_link && (
                      <a
                        aria-label="Linkedin Account"
                        target="_blank"
                        href={details?.other_customations?.linkedin_link}
                      >
                        {" "}
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.21953 2.523C5.19153 1.233 4.26453 0.25 2.75953 0.25C1.25353 0.25 0.269531 1.233 0.269531 2.523C0.269531 3.786 1.22453 4.797 2.70153 4.797H2.72953C4.26453 4.797 5.21953 3.786 5.21953 2.523ZM4.92953 6.593H0.529531V19.75H4.92953V6.593ZM15.7325 6.284C18.6275 6.284 20.7985 8.164 20.7985 12.206V19.75H16.3985V12.711C16.3985 10.943 15.7615 9.736 14.1685 9.736C12.9535 9.736 12.2285 10.55 11.9105 11.336C11.7945 11.617 11.7655 12.009 11.7655 12.402V19.75H7.36553C7.36553 19.75 7.42353 7.828 7.36553 6.593H11.7655V8.457C12.3505 7.561 13.3955 6.284 15.7325 6.284Z"
                            fill="#240B3B"
                          />
                        </svg>
                      </a>
                    )}

                    {details?.other_customations?.pinterest_link && (
                      <a
                        aria-label="Pinterest Account"
                        target="_blank"
                        href={details?.other_customations?.pinterest_link}
                      >
                        <svg
                          width="23"
                          height="22"
                          viewBox="0 0 23 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.54283 21.494C9.59883 21.813 10.6658 22 11.7988 22C14.7162 22 17.5141 20.8411 19.577 18.7782C21.6399 16.7153 22.7988 13.9174 22.7988 11C22.7988 9.55546 22.5143 8.12506 21.9615 6.79048C21.4087 5.4559 20.5984 4.24327 19.577 3.22183C18.5556 2.20038 17.3429 1.39013 16.0083 0.837325C14.6738 0.284523 13.2434 0 11.7988 0C10.3543 0 8.92389 0.284523 7.58931 0.837325C6.25473 1.39013 5.0421 2.20038 4.02065 3.22183C1.95775 5.28473 0.798828 8.08262 0.798828 11C0.798828 15.675 3.73583 19.69 7.88283 21.274C7.78383 20.416 7.68483 18.997 7.88283 18.018L9.14783 12.584C9.14783 12.584 8.82883 11.946 8.82883 10.934C8.82883 9.416 9.77483 8.283 10.8528 8.283C11.7988 8.283 12.2388 8.976 12.2388 9.867C12.2388 10.813 11.6118 12.166 11.2928 13.464C11.1058 14.542 11.8648 15.488 12.9648 15.488C14.9228 15.488 16.4408 13.398 16.4408 10.45C16.4408 7.81 14.5488 6.006 11.8318 6.006C8.72983 6.006 6.90383 8.316 6.90383 10.747C6.90383 11.693 7.21183 12.65 7.71783 13.277C7.81683 13.343 7.81683 13.431 7.78383 13.596L7.46483 14.795C7.46483 14.982 7.34383 15.048 7.15683 14.916C5.74883 14.3 4.93483 12.298 4.93483 10.681C4.93483 7.205 7.39883 4.048 12.1508 4.048C15.9348 4.048 18.8828 6.765 18.8828 10.373C18.8828 14.157 16.5398 17.193 13.1848 17.193C12.1178 17.193 11.0728 16.621 10.6988 15.95L9.96183 18.557C9.70883 19.503 9.01583 20.768 8.54283 21.527V21.494Z"
                            fill="#240B3B"
                          />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VenuePharmacy;
